import { Geometry } from '@tcc/common';
import { SeasonName } from '../../../../../types/Season';
import { Location } from '../../../../../types/Location';

export interface ArdRequestLifecycle {
  requestId?: string;
  cached?: boolean;
  resumed?: boolean;
  wasCanceled?: boolean;
  pollAttemptCount: number;
  submitStartedAt?: number;
  submitCompletedAt?: number;
  pollingStartedAt?: number;
  pollingCompletedAt?: number;
  reportFetchStartedAt?: number;
  reportFetchCompletedAt?: number;
}

export interface BaseQueryParams {
  fieldUUID: string;
  geometry: Geometry | Location | undefined;
  geometryHash: string | undefined;
}
export interface ArdQueryParams extends BaseQueryParams {
  cropId: string;
  seasonName: SeasonName;
  seasonYear: number;
}

export type MaybeArdQueryParams = Omit<ArdQueryParams, 'cropId' | 'seasonName'> & {
  cropId?: string;
  seasonName?: SeasonName;
};

export interface InternalArdQueryParams extends ArdQueryParams {
  reportReferenceId: string;
}

export interface LegacyQueryParams extends BaseQueryParams {
  seasonTag: string;
}

export type QueryParams = ArdQueryParams | LegacyQueryParams;
export type MaybeQueryParams = MaybeArdQueryParams | LegacyQueryParams;
export interface UseReportQueryParams<T = MaybeQueryParams> {
  activityExists?: boolean;
  reportQueryEnabled: boolean;
  lastReportGraphQlErrorRef: React.MutableRefObject<string | undefined>;
  ardRequestLifecycleRef?: React.MutableRefObject<ArdRequestLifecycle>;
  queryParams: T;
}

export const isArdFullQueryParams = (params: QueryParams | MaybeQueryParams): params is ArdQueryParams => {
  const ardParams = params as ArdQueryParams;

  return Boolean(ardParams.seasonName && ardParams.cropId);
};

export const isLegacyQueryParams = (params: QueryParams | MaybeQueryParams): params is LegacyQueryParams => 
  (params as LegacyQueryParams).seasonTag !== undefined;

export const isArdQueryParams = (params: LegacyQueryParams | ArdQueryParams): params is ArdQueryParams =>
  (params as ArdQueryParams).seasonName !== undefined;
